import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiPython,
  DiGit,
  DiJava,
} from "react-icons/di";
import {
  SiFirebase,
  SiNextdotjs,
  SiExpress,
  SiMongodb,
  SiPowerbi,
  SiTailwindcss,
  SiBootstrap,
  SiChakraui,
  SiGooglecloud,
  SiFigma,
} from "react-icons/si";
import { TbSquareRoundedLetterC } from "react-icons/tb";
import { FaHtml5, FaCss3 } from "react-icons/fa";
import { GrMysql } from "react-icons/gr";
import Particle from "../Particle";

function Techstack() {
  return (
    <div
      style={{
        maxWidth: "98vw",
        paddingTop: "150px",
        color: "white",
      }}
    >
      <Particle />
      <h1 className="project-heading">
        Professional <strong className="purple">Skillset </strong>
      </h1>
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
        <Col xs={4} md={2} className="tech-icons">
          <DiJava />
          <p className="fs-5">Java</p>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <TbSquareRoundedLetterC />
          <p className="fs-5">C</p>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <FaHtml5 />
          <p className="fs-5">HTML</p>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <FaCss3 />
          <p className="fs-5">CSS</p>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <DiJavascript1 />
          <p className="fs-5">JavaScript</p>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiTailwindcss />
          <p className="fs-5">TailwindCSS</p>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiBootstrap />
          <p className="fs-5">Bootstrap</p>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <DiNodejs />
          <p className="fs-5">Node.js</p>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <DiReact />
          <p className="fs-5">React.js</p>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiExpress />
          <p className="fs-5">Express.js</p>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiMongodb />
          <p className="fs-5">MongoDB</p>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiNextdotjs />
          <p className="fs-5">Next.js</p>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <DiGit />
          <p className="fs-5">Git</p>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiFirebase />
          <p className="fs-5">Firebase</p>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <GrMysql />
          <p className="fs-5">MySQL</p>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiChakraui />
          <p className="fs-5">ChakraUI</p>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <DiPython />
          <p className="fs-5">Python</p>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiPowerbi />
          <p className="fs-5">PowerBI</p>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiGooglecloud />
          <p className="fs-5">Google Cloud</p>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiFigma />
          <p className="fs-5">Figma</p>
        </Col>
      </Row>
    </div>
  );
}

export default Techstack;
